const constants = {
  nonStickyModules: [
    'shop-canada-compare-cards',
    'shop-canada-hub',
    'shop-japan-compare-cards',
    'shop-mexico-compare-cards',
    'shop-mexico-hub',
    'international-shop-product-details-france',
  ],
  UPLIFT_FR: {
    SERVICE_CARDS: ['carte-platinum-americanexpress'],
  },
};

export default constants;
